import React from "react";
import { Button } from "@mui/material";
import { observer } from "mobx-react";
import { PageLayout } from "../common/layout";
import { useRootStore } from "../store/contexts";

export const AuthorHome = observer(() => {
  const rootStore = useRootStore();
  const { authStore, langStore } = rootStore;

  if (authStore.status === "logged" && authStore.me !== null) {
    return (
      <PageLayout>
        <h1>{langStore.authorWelcome(authStore.me.name ?? "")}</h1>
        <Button
          variant="outlined"
          onClick={() => {
            authStore.logout();
            rootStore.router.replace("/");
          }}
        >
          {langStore.logOutLabel}
        </Button>
      </PageLayout>
    );
  }
  return (
    <PageLayout>
      <h1>{langStore.homeTitle}</h1>
      <Button onClick={() => rootStore.router.goTo("/login")}>
        {langStore.logInLabel}
      </Button>
    </PageLayout>
  );
});
